/**
 * 红包雨活动类型定义
 */

export const RED_PACKET_RAIN_PHASE = {
  None: 'none',
  Preview: 'preview',
  Warning: 'warning',
  Playing: 'playing',
  Result: 'result'
} as const

export type RedPacketRainPhase = (typeof RED_PACKET_RAIN_PHASE)[keyof typeof RED_PACKET_RAIN_PHASE]

/** 日程状态 value 不能改，影响 CSS class */
export const RED_PACKET_RAIN_SCHEDULE_STATUS = {
  Upcoming: 'upcoming',
  Preparing: 'active',
  InProcess: 'processing',
  Finished: 'finished'
} as const

export type RedPacketRainScheduleStatus =
  (typeof RED_PACKET_RAIN_SCHEDULE_STATUS)[keyof typeof RED_PACKET_RAIN_SCHEDULE_STATUS]

export const WARNING_DURATION_MS = 5 * 1000

export interface RainTimeSettingItem {
  id: string
  startTime: number
}

export interface ActivityDetailRaw {
  activityId: number | string
  activityStartTime: number
  activityEndTime: number
  rainTimeSettings: string
  preStartTimeHint: number
  delayDuration: number
  countdownSeconds: number
  prizePoolLimit?: string
  activityState: number
  activityName?: string
  activityNameZh?: string
  activityNameEn?: string
  activityNameVi?: string
  activityNameHi?: string
  activityNameTa?: string
  activityNameMs?: string
  activityNamePt?: string
  bannerDetail?: string
  bannerDetailZh?: string
  bannerDetailEn?: string
  bannerDetailVi?: string
  bannerDetailHi?: string
  bannerDetailTa?: string
  bannerDetailMs?: string
  bannerDetailPt?: string
  description?: string
  descriptionZh?: string
  descriptionEn?: string
  descriptionVi?: string
  descriptionHi?: string
  descriptionTa?: string
  descriptionMs?: string
  descriptionPt?: string
}

export interface GrabResultRaw {
  success: boolean
  packetId?: string
  amount: number
}

export interface TimePeriod {
  id: string
  time: string
  startTime: number
  status: RedPacketRainScheduleStatus
}

export interface ScheduleDay {
  date: number
  displayDate: string
  status: RedPacketRainScheduleStatus
  timePeriods: TimePeriod[]
}

export interface SessionInfo {
  id: string
  startTime: number
  displayTime: string
  displayDate: string
}

export interface ActivityConfig {
  activityId: string
  activityName: string
  banner: string
  activityStartTime: number
  activityEndTime: number
  validityWindow: number
  animationDuration: number
  previewMinutes: number
  activityRule: string
  serverTime: number
  scheduleDays: ScheduleDay[]
}

export interface RedPacketRainResult {
  hitCount: number
  rewardAmount: number
  hasReward: boolean
}
